import type { ReactNode } from 'react';

import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';

interface Props {
  title: string;
  subTitle: string;
  children?: ReactNode;
}

export default function HeaderDropDownTitle({ title, subTitle, children }: Props) {
  return (
    <Box sx={{ marginTop: 4, width: { lg: 260 }, maxWidth: { md: 260 } }}>
      <Typography variant="h3" component="div" sx={{ whiteSpace: 'nowrap' }}>
        {title}
      </Typography>
      <Typography variant="caption" color="textPrimary" component="div">
        {subTitle}
      </Typography>

      {children && <Box sx={{ marginTop: 1 }}>{children}</Box>}
    </Box>
  );
}
